import { render, staticRenderFns } from "./sandPay.vue?vue&type=template&id=eceef734&scoped=true&"
import script from "./sandPay.vue?vue&type=script&lang=js&"
export * from "./sandPay.vue?vue&type=script&lang=js&"
import style0 from "./sandPay.vue?vue&type=style&index=0&id=eceef734&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eceef734",
  null
  
)

export default component.exports